import { MessageDto } from "@resume-studio/dto";
import { AxiosInstance, AxiosResponse } from "axios";

// Hits the dedicated `/admin/auth/refresh` endpoint (NOT the consumer-app
// `/auth/refresh`) so it reads + writes the `admin_*` cookies only. The
// axios instance is passed in so the interceptor can use a separate
// instance to break the refresh-loop deadlock — same pattern as the
// consumer client.
export const refreshToken = async (axios: AxiosInstance) => {
  const response = await axios.post<MessageDto, AxiosResponse<MessageDto>>("/admin/auth/refresh");

  return response.data;
};
